/** Match Dashboard.js number display for card metrics. */
export const formatNumber = (num) => {
    if (num == null || Number.isNaN(Number(num))) return '0';
    const n = Number(num);
    return n >= 1000 ? n.toLocaleString() : String(n);
};

/** Format currency from API decimal prices (per kg). */
export const formatMoney = (amount) => {
    if (amount == null || Number.isNaN(Number(amount))) return '—';
    const n = Number(amount);
    return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

/** List / contract prices per kg: keep decimals so e.g. 3.5 does not display as 4. */
export const formatPricePerKg = (amount) => {
    if (amount == null || Number.isNaN(Number(amount))) return '—';
    const n = Number(amount);
    return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

/** Values stored as kilograms (API *_qty_kg, standard_quantity in kg, etc.) → metric tonnes. */
export const formatMetricTonnesFromKg = (kg, maxDecimals = 4) => {
    if (kg == null || Number.isNaN(Number(kg))) return '—';
    const t = Number(kg) / 1000;
    return `${t.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: maxDecimals })} t`;
};

/**
 * Interpret `value` in `units` (GLOBAL_UNITS: kg, t, 50kg) and return metric tonnes, or null if not a mass unit.
 */
export const quantityValueToMetricTonnes = (value, units) => {
    if (value == null || Number.isNaN(Number(value))) return null;
    const v = Number(value);
    const u = (units || 'kg').toString().toLowerCase().replace(/\s/g, '');
    if (u === 't' || u === 'tonne' || u === 'tonnes') return v;
    if (u === 'kg' || u === 'kilogram' || u === 'kilograms') return v / 1000;
    if (u === '50kg') return (v * 50) / 1000;
    return null;
};

export const formatQuantityAsMetricTonnes = (value, units, maxDecimals = 4) => {
    const t = quantityValueToMetricTonnes(value, units);
    if (t == null || Number.isNaN(t)) return '—';
    return `${t.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: maxDecimals })} t`;
};

/**
 * Inventory / mixed rows: show metric t when unit is a mass unit; otherwise raw value + unit.
 */
export const formatMassOrRaw = (value, unit) => {
    const t = quantityValueToMetricTonnes(value, unit);
    if (t != null && !Number.isNaN(t)) return formatQuantityAsMetricTonnes(value, unit);
    if (value == null || value === '') return '—';
    const u = unit != null && String(unit).trim() !== '' ? ` ${unit}` : '';
    return `${Number(value).toLocaleString()}${u}`;
};
